import React from 'react'
import { touritemProps } from './touritem-interface'
import { Button } from 'antd'

const Touritem = ({ backdrop, subtitle, title, desc, hasPrev, nextAction, prevAction, skipAction, tourbgClass, isTourEnd }: touritemProps) => {
  return (
    <div className={`pt-[1.2rem] mb-[1rem] pb-[0.5rem] ${tourbgClass}`}>
      <div className='flex justify-center'>
        <img src={backdrop} alt="" className='w-[9.2rem] h-[7.9rem]' />
      </div>

      <div className='px-[1.5rem] pt-10 pb-[0.5rem]'>
        <div className='mb-[0.5rem] border-b border-appcolorslightgrey pb-[0.5rem]'>
          <p className='text-appcolorfaintpurple text-[14px] mb-[0.5rem] leading-[17px]'
          >
            {subtitle}
          </p>
          <p className='font-semibold text-appcolorblackfaint text-[18px] leading-[22px]'>
            {title}
          </p>
        </div>

        <p className='text-appcolorpurplesix text-base mb-[1.2rem]'>
          {desc}
        </p>

        <div className='flex items-center justify-between'>
          <div className='flex'>
            {
              hasPrev ?
                <Button
                  className='mr-[1.4rem] custom-grey-btn black-text smaller-border-radius smaller-padding'
                  onClick={() => {
                    prevAction()
                  }}
                >
                  Back
                </Button> : null
            }

            <Button
              className='custom-primary-one-btn white-text smaller-border-radius smaller-padding'
              onClick={() => {
                nextAction()
              }}
            >
              Next
            </Button>
          </div>


          <div className='flex items-center cursor-pointer w-fit'
            onClick={() => {
              skipAction()
            }}
          >
            <span className='text-appcolorpurpleseven font-bold text-base pr-[0.5rem]'>
              Skip Tour
            </span>
            <div>
              <img src="/img/vectors/doubleright.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

Touritem.defaultProps = {
  hasPrev: true,
  tourbgClass: 'custom-pink-spiral-bg-linear',
  isTourEnd: false
}

export default Touritem